import { Api } from "../config/request";

// API function to login user
const login = async (data) => {
    let response = await Api.PostRequest("/login", data);
    return response.data;
};

// API function to logout user
const logout = async () => {
    let response = await Api.PostRequest("/logout");
    return response.data;
};

// API function to signup user
const signUp = async (data) => {
    let response = await Api.PostRequest("/signUp", data);
    return response.data;
};

// API function to signup user
const signUpWithoutOtp = async (data) => {
    let response = await Api.PostRequest("/signUpWithoutOtp", data);
    return response.data;
};

// API function to verify OTP
const verifyOTP = async (data) => {
    let response = await Api.PostRequest("/verifyOTP", data);
    return response.data;
};

// API function to resend OTP
const resendOTP = async (data) => {
    let response = await Api.PostRequest("/resendOTP", data);
    return response.data;
}

// API function to create password
const createPassword = async (data) => {
    let response = await Api.PostRequest("/create-password", data);
    return response.data;
}

// API function to create password
const forgotPassword = async (data) => {
    let response = await Api.PostRequest("/forgot-password", data);
    return response.data;
}

// API function to create password
const resetPassword = async (data) => {
    let response = await Api.PostRequest("/reset-password", data);
    return response.data;
}

// API function to get university details
const getUniversityDetails = async ( data ) => {
    let response = await Api.PostRequest("/getUniversityDetails", data);
    return response.data;
};

// API function to get user profile
const getUserProfileDetails = async ( data ) => {
    let response = await Api.PostRequest("/getUserProfileDetails", data);
    return response.data;
};

const googleAuth = async (data) => {
    let response = await Api.PostRequest("/auth/google", data);
    return response.data;
}
const authApi = {
    login,
    signUp,
    verifyOTP,
    resendOTP,
    createPassword,
    getUniversityDetails,
    logout,
    getUserProfileDetails,
    forgotPassword,
    resetPassword,
    googleAuth,
    signUpWithoutOtp,
};

export default authApi;
